import * as React from 'react'
import { CircularProgress, withStyles, WithStyles } from '@zn-material-ui'
import classnames from 'classnames'

import styles from './style'
import Button, { IButtonProps } from '../Button'
interface IProps extends WithStyles<typeof styles> {
  children: any
  loading: boolean
}

const AdornedButton = (props: IProps & IButtonProps) => {
  const { classes, children, loading, ...buttonProps } = props

  let className = loading ? classes.forbidEvents : ''
  if (buttonProps.className) {
    className = classnames(buttonProps.className, className)
  }

  return (
    <Button {...buttonProps} className={className}>
      {children}
      {loading && (
        <CircularProgress
          className={classes.spinner}
          color="secondary"
          size={18}
        />
      )}
    </Button>
  )
}

export default withStyles(styles)(AdornedButton)
